export const tabCountHandle = (count?: number | null) => {
  if (count && count > 0) {
    return `(${count})`;
  } else return '';
};
